import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface ProductionOrderDetailsBatchDocumentsProps extends ProductionOrderScreenProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const ProductionOrderDetailsBatchDocumentsComponent: FC<ProductionOrderDetailsBatchDocumentsProps> = ({
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  productionOrdersSearch,
  updateHeaderConfig,
  loadSingleBatch,
  batch,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    updateHeaderConfig,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
  });

  const batchId = batch?.data?.productionBatchId;

  return (
    <DetailsPageWrapper title={title.batch}>
      {batchId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={batchId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Batch} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsBatchDocuments = connect(({ batch: { batch } }) => ({ batch }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsBatchDocumentsComponent);

export { ProductionOrderDetailsBatchDocuments };
